import { createSelector } from '@reduxjs/toolkit';
import { emptyObject } from 'vet-bones/constants';

import { memoizeSelectorFactory } from 'src/selectors/memoizeSelectorFactory';
import { projectSelector } from 'src/selectors/project';
import { ProjectVirtualGraph } from 'src/store/state/projects';

export const projectVirtualGraphsByIdSelector = memoizeSelectorFactory(
  (projectId: string) =>
    createSelector(
      projectSelector(projectId),
      (project) =>
        project?.virtualGraphsById ||
        (emptyObject as unknown as Record<string, ProjectVirtualGraph>)
    )
);
